import { useState } from 'react';

/**
 * Manages temporary input draft values for forms/inputs
 * Used by: OrgRegistryManagement, OrgTechContextSetup
 * Get, set, clear individual or all drafts
 */
export const useDraftState = () => {
  const [drafts, setDrafts] = useState({});

  const getDraft = (key) => drafts[key] ?? '';

  const setDraft = (key, value) => {
    setDrafts((prev) => ({ ...prev, [key]: value }));
  };

  const clearDraft = (key) => {
    setDraft(key, '');
  };

  const clearAllDrafts = () => {
    setDrafts({});
  };

  return {
    drafts,
    getDraft,
    setDraft,
    clearDraft,
    clearAllDrafts,
  };
};
